<script>
  import './projectPreview.css'
  import { ethers } from 'ethers'
  import { getProjectMetaService } from '../../../services/api'
  import { getProjectDetailService } from '../../../services/projectDetailService'
  import { getContext, onMount } from 'svelte'

  import {
    isCalculatingPurchaseLimit,
    isLoaderActive,
    isTransactionConfirmed,
    projectDetail,
    projectSaleDetails,
    tokenPurchased,
  } from '../../store'
  import SaleArtifact from '../../abi/Sale.json'
  import { signer, signerAddress, chainId } from 'svelte-ethers-store'
  import {
    formatNumber,
    getAfterTimestampDate,
    getAfterTimeStampStrapi,
    getERC20,
    getTokenPrice,
    getWalletCap,
    getProjectStatus,
    formattedChainID,
  } from '../../utils'
  import ProjectCardPreview from './project-card-preview/ProjectCardPreview.svelte'
  import ProjectPreviewTab from './project-preview-tab/ProjectPreviewTab.svelte'
  import ProjectDetailPreview from './project-preview-tab/project-detail-preview/ProjectDetailPreview.svelte'
  import { formatUnits } from 'ethers/lib/utils'
  import ProjectTokenDetail from './project-preview-tab/project-token-detail/ProjectTokenDetail.svelte'
  import ProjectTransactionTab from './project-preview-tab/project-transaction-tab/ProjectTransactionTab.svelte'
  import { getSaleTransactionMetaService } from '../../../services/saleTransactionApi'
  import {
    PARTIAL_TIME_FORMAT,
    transactionType,
    COMPLETE_TIME_FORMAT,
  } from '../../constants/constants'
  import ProjectReward from './project-preview-tab/project-reward/ProjectReward.svelte'
  import WrongRaisedModal from '../../components/wrong-raised-modal/WrongRaisedModal.svelte'

  const { open } = getContext('simple-modal')

  export let params = {}

  let currentStep = 1

  let tokenValues,
    reserveValues,
    saleContract,
    saleData,
    projectTierData,
    projectDetailResp,
    fakeProjectDetails
  let saleCardDetails = {
    saleAddress: $projectDetail.sale_address,
    raiseTarget: $projectDetail.project_raise_target,
    totalSupply: $projectDetail.total_available_token,
    startTime: getAfterTimeStampStrapi(
      $projectDetail.project_start_time,
      PARTIAL_TIME_FORMAT,
    ),
    endTime: getAfterTimeStampStrapi(
      $projectDetail.project_end_time,
      PARTIAL_TIME_FORMAT,
    ),
    walletCap: $projectDetail.individual_purchase_limit,
    totalRaised: '',
    price: $projectDetail.project_token_price,
    percentRaised: '',
    tokenName: $projectDetail.token_name,
    tokenSymbol: $projectDetail.token_symbol,
    chainID: $projectDetail.chain?.chain_id,
  }
  const setTokenPrice = async () => {
    if (
      $projectDetail.sale_address &&
      formattedChainID($chainId) == saleCardDetails.chainID &&
      !saleContract
    ) {
      const { sale, reserve, token } = await initSaleContract(
        $signer,
        $projectDetail.sale_address,
      )
      saleContract = sale
      reserveValues = reserve
      tokenValues = token
    }
  }

  const setCurrentStep = (newStep) => {
    currentStep = newStep
  }

  const setFakeRaiseDetail = (projectDetailResp) => {
    saleCardDetails = {
      walletCap: projectDetailResp.individual_purchase_limit,
      raiseTarget: projectDetailResp.project_raise_target,
      totalSupply: projectDetailResp.total_available_token,
      startTime: new Date(projectDetailResp.project_start_time).toLocaleString(
        'en-US',
      ),
      endTime: new Date(projectDetailResp.project_end_time).toLocaleString(
        'en-US',
      ),
      totalRaised:
        ((projectDetailResp.progress_bar_status *
          projectDetailResp.total_available_token) /
          100) *
        projectDetailResp.project_token_price,
      price: projectDetailResp.project_token_price,
      tokenName: projectDetailResp.token_name,
      tokenSymbol: projectDetailResp.token_symbol,
      percentRaised: projectDetailResp.progress_bar_status,
      chainID: $projectDetail.chain?.chain_id,
    }
  }

  const setProjectDetail = async (flagModal) => {
    isLoaderActive.set(true)
     projectDetailResp = await getProjectDetailService(params.projectId)
    let { project_start_time, project_end_time, flag } = projectDetailResp
    projectDetailResp.project_status = getProjectStatus(
      project_start_time,
      project_end_time,
    )
    projectDetail.set(projectDetailResp)
    if (!$projectDetail.sale_address) {
      setFakeRaiseDetail(projectDetailResp)
    }
    isLoaderActive.set(false)
    if (flagModal && flag) {
      open(WrongRaisedModal)
    }
    await setProjectData()
  }

  const getSalesTransactions = async () => {
    isCalculatingPurchaseLimit.set(true)
    tokenPurchased.set(0)
    if (
      $signerAddress &&
      $projectDetail.sale_address &&
      $projectDetail?.version.version &&
      $projectDetail?.chain.chain_id
    ) {
      const transactions = await getSaleTransactionMetaService(
        $projectDetail.sale_address,
        $signerAddress,
        $projectDetail.version.version,
        $projectDetail.chain.chain_id,
      )
      let sum = 0
      transactions.data.saleTransactions.forEach((transaction) => {
        sum +=
          transaction.__typename === transactionType.Buy
            ? formatNumber(
                transaction.receipt.units,
                transaction.saleContract.token.decimals,
              )
            : -formatNumber(
                transaction.receipt.units,
                transaction.saleContract.token.decimals,
              )
      })
      isCalculatingPurchaseLimit.set(false)
      tokenPurchased.set(sum)
    }
  }


  const setProjectData = async () => {
    if ($projectDetail.sale_address && $projectDetail?.version?.version && $projectDetail.chain.chain_id) {
      const { data } = await getProjectMetaService(
        $projectDetail.sale_address,
        $projectDetail.version.version,
        $projectDetail.chain.chain_id,
      )
      if (data?.sales.length == 0) return
      setSaleData(data?.sales[0])
      await getSalesTransactions()
    }
  }

  const setSaleData = (sale) => {
    projectSaleDetails.set(sale)
    saleCardDetails = {
      project_address: sale.id,
      raiseTarget: Number(
        formatUnits(sale.minimumRaise, sale.reserve.decimals),
      ),
      totalSupply: Number(
        +formatUnits(sale.token.totalSupply, sale.token.decimals),
      ),
      startTime: getAfterTimestampDate(
        sale.canStartStateConfig,
        COMPLETE_TIME_FORMAT,
      ).toLocaleString(),
      endTime: getAfterTimestampDate(
        sale.canEndStateConfig,
        COMPLETE_TIME_FORMAT,
      ).toLocaleString(),
      walletCap: getWalletCap(sale),
      totalRaised: Number(
        +formatUnits(sale.totalRaised, sale.reserve.decimals),
      ),
      price: getTokenPrice(sale),
      tokenName: sale.token.name,
      tokenSymbol: sale.token.symbol,
      percentRaised: sale.percentRaised,
      saleStatus: sale.saleStatus,
      chainID: $projectDetail.chain?.chain_id,
    }
    setTokenPrice()
  }

  $: if ($isTransactionConfirmed) {
    setProjectData()
    ;(async () => await getSalesTransactions())()
    isTransactionConfirmed.set(false)
  }

  if (params.projectId) {
    if ($projectDetail.sale_address) setProjectData()
    setProjectDetail(true)
  }

  const socialLinks = () => {
    let {
      facebook_url,
      instagram_url,
      twitch_url,
      twitter_url,
      youtube_url,
      linked_in_url,
      discord_url,
      telegram_url,
    } = $projectDetail

    return {
      facebook_url,
      instagram_url,
      twitch_url,
      twitter_url,
      youtube_url,
      linkedin: linked_in_url,
      discord_url,
      telegram_url,
    }
  }

  const initSaleContract = async (signer, address) => {
    isLoaderActive.set(true)
    const sale = new ethers.Contract(address, SaleArtifact.abi, signer)
    const reserve = await getERC20(await sale.reserve(), signer)
    const token = await getERC20(await sale.token(), signer)
    isLoaderActive.set(false)
    return { sale, reserve, token }
  }

  onMount(() => {
    window.scrollTo(0, 0)
  })
</script>

<div class="project-preview-setup">
  <div class="container">
    {#if !$projectDetail.featured && !$projectDetail.is_verified}
      <div class="disclaimer-modal">
        <h1>Disclaimer</h1>
        <p>
          Please note that participating in a Permissionless Raise through
          Polinate is a high-risk endeavour and that the value of the tokens
          that you've received in exchange for contributing to such a raise
          might go to '0'. Polinate is not liable for any losses incurred by
          using our platform. Be careful and do your own research before buying
          into any of these Raises.
        </p>
      </div>
    {/if}
    <ProjectCardPreview
      {projectTierData}
      {saleCardDetails}
      {saleData}
      sale={saleContract}
      reserve={reserveValues}
      token={tokenValues} />
    <div class="flex social-networks-wrap">
      {#if $projectDetail.facebook_url || $projectDetail.instagram_url || $projectDetail.twitch_url || $projectDetail.twitter_url || $projectDetail.youtube_url || $projectDetail.linked_in_url || $projectDetail.discord_url || $projectDetail.telegram_url}
        <div class="detail-social flex items-center">
          <strong>Social Network:</strong>
          {#each Object.entries(socialLinks()) as [key, url]}
            {#if url}
              <a
                href={url.includes('http') ? url : `https://${url}`}
                target="_blank">
                <img
                  src={`./images/ic_${key.replaceAll('_url', '')}.svg`}
                  alt={key.replaceAll('_url', '')} />
              </a>
            {/if}
          {/each}
        </div>
      {/if}
    </div>
  </div>
  <ProjectPreviewTab
    {setCurrentStep}
    {currentStep}
    {saleContract}
    rewardVisible={$projectDetail && $projectDetail.rewards} />
  <div class="tabs-section">
    <div class="container">
      {#if currentStep === 1}
        <ProjectDetailPreview
          source={$projectDetail && $projectDetail.project_story} />
      {/if}
      {#if currentStep === 2}
        <ProjectTokenDetail
          source={$projectDetail && $projectDetail.token_details} />
      {/if}
      {#if currentStep === 3}
        <ProjectReward
          source={$projectDetail && $projectDetail.rewards}
          rewardDistributionDate={$projectDetail && $projectDetail.reward_distribution_date} />
      {/if}
      {#if currentStep === 4}
        <ProjectTransactionTab
          endTime={saleCardDetails.endTime}
          {saleContract}
          bind:currentStep />
      {/if}

    </div>
  </div>
</div>
